export type DocumentTypes = "RA" | "AC" | "ACS" | "ACM" | "ACF" | "ACP" | "URS" | "FS"
    | "DS" | "FAT" | "SAT" | "IQ" | "OQ" | "PQ" | "DQ" | "CL" | "VMP" | "CUSTOM"
    | "PROCEDURE" | "INSTRUCTION" | "FORM"
    
export type DocumentLanguages = "MULTI" | "EN" | "PL"

export type DocumentCreationModes = "EMPTY" | "TEMPLATE" | "DOCUMENT"

export type UrsNumberingMode = "ONLY_SIMPLE_REQ" | "UNIQUE_REQ" | "DECIMAL_HIERARCHICAL"

export type DocSectionType = "GROUP"
    | "APPROVAL_CARD"
    | "VERSIONS_HISTORY"
    | "RESPONSIBILITIES"
    | "QUESTIONS_WITH_LIST"
    | "TESTS"
    | "TESTS_TEAM"
    | "DQ_MAPPINGS"
    | "DEVIATIONS"
    | "VALIDATED_OBJECT"
    | "RISK_ANALYSIS"
    | "VALIDATION_TEAM"
    | "TESTS_SCHEDULE"
    | "TESTS_METHODOLOGY"
    | "ATTACHMENTS"
    | "REQUIREMENTS"
    | "RA_MITIGATION_SCHEDULE"
    | "RA_RECOMMENDED_ACTIONS"
    | "RA_LIMITS"
    | "DOC_REFERENCES"
    | "RA_SUMMARY"
    | "FORM"

export const DOCUMENT_TYPES: DocumentTypes[] = ["RA", "AC", "ACS", "ACM", "ACF", "ACP", "URS", "FS", "DS", "FAT", "SAT", "IQ", "OQ", "PQ", "DQ", "CL", "VMP", "CUSTOM", "PROCEDURE", "INSTRUCTION", "FORM"]

export const DOC_SECTION_TYPES: DocSectionType[] = ["GROUP", "APPROVAL_CARD", "VERSIONS_HISTORY", "RESPONSIBILITIES", "QUESTIONS_WITH_LIST", "TESTS", "TESTS_TEAM", "DQ_MAPPINGS", "DEVIATIONS", "VALIDATED_OBJECT", "RISK_ANALYSIS", "VALIDATION_TEAM", "TESTS_SCHEDULE", "TESTS_METHODOLOGY", "ATTACHMENTS", "REQUIREMENTS"]
